import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import CropperComponent from './Cropper';
import * as styles from './Cropper.scss';

class ModalCropper extends Component {
  render() {
    const {
      handleCropp,
      translate,
      openModal,
      img,
      handleCroppStart,
      handleCroppEnd,
      onRequestClose,
      hideCropperModal
    } = this.props;

    return (
      <Modal
        isOpen={openModal}
        className={styles.processModal}
        onRequestClose={onRequestClose}
        overlayClassName={styles.processOverlay}
      >
        <CropperComponent
          img={img}
          hideCropperModal={hideCropperModal}
          handleCropp={handleCropp}
          translate={translate}
          handleCropStart={handleCroppStart}
          handleCropEnd={handleCroppEnd}
        />
      </Modal>
    );
  }
}

ModalCropper.propTypes = {
  hideCropperModal: PropTypes.func,
  handleCropp: PropTypes.func,
  handleCroppStart: PropTypes.func,
  handleCroppEnd: PropTypes.func,
  onRequestClose: PropTypes.func,
  translate: PropTypes.func,
  openModal: PropTypes.bool,
  img: PropTypes.string
};

export default ModalCropper;
